/**
 * Search object types. Mirrors App\Support\ModelTypeUtil::classToType.
 */
export const RELAY = 'relay'
export const ASSET_RADIO = 'asset_radio'
export const USER = 'user'
